export const COURSE_LEADERS_CONST = {
  NAME: 'name',
  ID: 'ID',
  IS_ARCHIVED: 'isArchived',
};

export const FILTERS_ARGS = {
  SEARCH: 'search',
  IS_ARCHIVED: 'is_archived'
};
